import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useSportConfig } from '../context/SportConfig';
import '../styles/Auth.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const sportConfig = useSportConfig();

  const [formData, setFormData] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.password || !formData.confirm) {
      setError('Please fill in both fields.');
      return;
    }

    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }

    if (formData.password !== formData.confirm) {
      setError('Passwords do not match.');
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/auth/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: formData.password }),
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.message || 'Failed to reset password.');
        return;
      }

      setSuccess(true);
      // Redirect to login after 3 seconds
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError('Unable to reach the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>{sportConfig?.appEmoji || '🎾'} Reset Password</h1>

        {success ? (
          <>
            <div className="success-message">
              Your password has been updated! Redirecting you to Login…
            </div>
            <p className="auth-footer">
              <Link to="/login" className="auth-link">Go to Login now</Link>
            </p>
          </>
        ) : (
          <>
            <p className="auth-subtitle">Enter your new password below.</p>

            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="password">New Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="At least 8 characters"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirm">Confirm New Password</label>
                <input
                  type="password"
                  id="confirm"
                  name="confirm"
                  value={formData.confirm}
                  onChange={handleChange}
                  placeholder="Repeat your new password"
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Updating…' : 'Update Password'}
              </button>
            </form>

            <p className="auth-footer">
              <Link to="/login" className="auth-link">← Back to Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
